module.exports = __webpack_public_path__ + "img/arts.1637e6f4.png";